/* ============================================================================
   Requests module route + nav registration.
   Self-registers the Dashboard, the New Request intake form, the draft editor,
   and the request-detail host with the registry. No shared file is edited.
   ============================================================================ */

import { registerRoute } from '../../app/registry';
import Dashboard from './Dashboard';
import RequestForm from './RequestForm';
import RequestDetail from './RequestDetail';

// Dashboard — the module landing page (KPI tiles + filterable list).
registerRoute({
  path: '/requests',
  element: <Dashboard />,
  nav: { label: 'Dashboard', order: 10, icon: '◲' },
  // No roles => any authenticated user. Row-level scoping happens server-side.
});

// New Request — the full intake form. Requesters and PMs can create.
registerRoute({
  path: '/requests/new',
  element: <RequestForm />,
  nav: { label: 'New Request', order: 20, icon: '＋', roles: ['Requester', 'Admin', 'SystemAdmin'] },
  roles: ['Requester', 'Admin', 'SystemAdmin'],
});

// Draft editor — reuses the intake form for an existing request. Not in nav.
registerRoute({
  path: '/requests/:id/edit',
  element: <RequestForm />,
  roles: ['Requester', 'Admin', 'SystemAdmin'],
});

// Detail — hosts the request-detail tab registry. Not shown in nav.
registerRoute({
  path: '/requests/:id',
  element: <RequestDetail />,
});
